/**
 * Manufacturer Archive App
 */

import { createApp } from 'vue';
import ManufacturerArchive from './components/ManufacturerArchive.vue';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('manufacturer-app');

	if (container) {
		const app = createApp(ManufacturerArchive);

		app.config.globalProperties.$wordpress = {
			ajaxUrl: window.jaeckleData?.ajaxUrl || '/wp-admin/admin-ajax.php',
			nonce: window.jaeckleData?.nonce || '',
			siteUrl: window.jaeckleData?.siteUrl || '',
		};

		app.mount('#manufacturer-app');
	}
});
